module.exports = __webpack_public_path__ + "static/media/CIT.33a05d86.jpg";